var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6998 15.7847C13.2041 17.0454 11.264 17.8064 9.14406 17.8064C4.4137 17.8064 0.578979 14.0174 0.578979 9.34328C0.578979 4.66921 4.4137 0.880127 9.14406 0.880127C11.2641 0.880127 13.2042 1.64119 14.6998 2.9019C16.1955 1.64122 18.1356 0.880172 20.2556 0.880172C24.9859 0.880172 28.8206 4.66926 28.8206 9.34333C28.8206 14.0174 24.9859 17.8065 20.2556 17.8065C18.1355 17.8065 16.1954 17.0454 14.6998 15.7847Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6998 15.7847C16.5414 14.2324 17.7092 11.9226 17.7092 9.34328C17.7092 6.76397 16.5414 4.45416 14.6998 2.90186C16.1955 1.64118 18.1356 0.880127 20.2556 0.880127C24.9859 0.880127 28.8206 4.66921 28.8206 9.34328C28.8206 14.0174 24.9859 17.8064 20.2556 17.8064C18.1356 17.8064 16.1955 17.0454 14.6998 15.7847Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6999 15.7849C16.5415 14.2326 17.7092 11.9228 17.7092 9.3435C17.7092 6.7642 16.5415 4.4544 14.6999 2.9021C12.8583 4.4544 11.6906 6.7642 11.6906 9.3435C11.6906 11.9228 12.8583 14.2326 14.6999 15.7849Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.c43416834fd6a59ae3fcfdec4ff4fb98.svg";
export { ForwardRef as ReactComponent };